import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { currencyFormatter } from "../../../../../utils/helpers/currencyFormatter";
import { renderDurationAsFormat } from "../../../../../utils/helpers/date";
import { getPrimaryActiveResource } from "../../../../../utils/helpers/user";

export const useRetroAmountColumn = () => {
    const { t } = useTranslation();
    return useMemo(() => ({
        id: "retroAmount",
        Header: t("retro-amount"),
        disableSortBy: true,
        accessor: "retroAmount",
        Footer: (value) => {
            let sum = 0;
            value?.data?.forEach((val) => sum += val?.retroAmount)
            return currencyFormatter(sum)
        },
        Cell: ({ value, row: { original } }) => {
            const job = getPrimaryActiveResource(original.jobs);
            return currencyFormatter(value || 0, 2, job?.currency);
        },
    }), [t]);
};


export const useRetroHoursColumn = () => {
    const { t } = useTranslation();
    return useMemo(() => ({
        id: "retroHours",
        Header: t("retro-hours"),
        accessor: "retroHours",
        disableSortBy: true,
        Footer: (value) => {
            let sum = 0;
            value?.data?.forEach((val) => sum += val?.retroHours)
            if (sum === 0) {
                return "--"
            }
            return renderDurationAsFormat(sum, "HH:mm", false, true)
        },
        Cell: ({ value, row: { original } }) => {
            if (value === 0) {
                return "--"
            }
            return renderDurationAsFormat(value || 0, "HH:mm", false, true);
        },
    }), [t]);
};

